import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ icon, label, value, sub, trend, color, loading, highlight }) => (
  <div className={`bg-card border rounded-xl p-5 flex flex-col gap-3 hover:shadow-md transition-all duration-200 ${highlight ? 'border-primary/30 shadow-gold' : 'border-border'}`}>
    <div className="flex items-center justify-between">
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${color}`}>
        <Icon name={icon} size={18} color="white" />
      </div>
      {trend !== undefined && (
        <span className={`text-xs font-medium flex items-center gap-1 ${trend >= 0 ? 'text-green-500' : 'text-red-500'}`}>
          <Icon name={trend >= 0 ? 'TrendingUp' : 'TrendingDown'} size={12} />
          {Math.abs(trend)?.toFixed(1)}%
        </span>
      )}
    </div>
    {loading ? (
      <div className="space-y-2 animate-pulse">
        <div className="h-7 bg-muted rounded w-24" />
        <div className="h-4 bg-muted rounded w-32" />
      </div>
    ) : (
      <>
        <div className="text-2xl font-bold text-foreground">{value}</div>
        <div className="text-xs text-muted-foreground">{label}</div>
        {sub && <div className="text-xs text-muted-foreground/70">{sub}</div>}
      </>
    )}
  </div>
);

const BuyerStatsCards = ({ stats, loading }) => {
  const cards = [
    {
      icon: 'Gavel',
      label: 'Active Bids',
      value: stats?.activeBids || 0,
      sub: 'Currently bidding',
      color: 'bg-primary',
      highlight: true,
    },
    {
      icon: 'Trophy',
      label: 'Auctions Won',
      value: stats?.auctionsWon || 0,
      sub: 'Total wins',
      color: 'bg-yellow-500',
    },
    {
      icon: 'Target',
      label: 'Win Rate',
      value: `${(stats?.winRate || 0)?.toFixed(1)}%`,
      sub: 'Wins vs. bids placed',
      color: 'bg-green-500',
      trend: stats?.winRateChange,
    },
    {
      icon: 'DollarSign',
      label: 'Total Spent',
      value: `$${(stats?.totalSpent || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      sub: 'On won auctions',
      color: 'bg-blue-500',
      trend: stats?.spendChange,
    },
    {
      icon: 'BarChart2',
      label: 'Total Bids Placed',
      value: (stats?.totalBidsPlaced || 0)?.toLocaleString(),
      sub: `Across ${stats?.totalAuctions || 0} auctions`,
      color: 'bg-purple-500',
    },
    {
      icon: 'TrendingUp',
      label: 'Avg Winning Bid',
      value: `$${(stats?.avgWinningBid || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      sub: 'Per won auction',
      color: 'bg-orange-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {cards?.map((card, i) => (
        <StatCard key={i} {...card} loading={loading} />
      ))}
    </div>
  );
};

export default BuyerStatsCards;
